import React from 'react';
import ModifierGroupsState from './modifierGroupsState/ModifierGroupsState';
import ModifierGroupsControlPanel from './components/ModifierGroupsControlPanel/ModifierGroupsControlPanel';
import ModifierGroups from './components/ModifierGroups/ModifierGroups';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const ModifierGroupsPage: React.FC = () => {
	return (
		<ModifierGroupsState>
			<div className={style.container} data-test="ModifierGroupsPage">
				<ModifierGroupsControlPanel />
				<ModifierGroups />
				<ModalWindows />
			</div>
		</ModifierGroupsState>
	);
};

export default ModifierGroupsPage;
